/**
 * Módulo Tuninho: a sincronização que avisa — card 1864753210497959381.
 *
 * Tudo aqui dentro é NOSSO e novo (Regra 8.15: arquivo novo não conflita; arquivo editado
 * conflita). O motor de sync do upstream (`@affine/nbstore`) não é tocado — o relógio se
 * constrói POR CIMA de `engine.doc.state$` e a prova sai por HTTP, independente do socket.
 *
 * O preço de não tocar o motor está declarado no Discovery (D3): expor o peer remoto ao
 * frontend custaria quatro arquivos quentes deles, e nada do que o card pede exige isso.
 */

import type { Framework } from '@toeverything/infra';

import { GlobalContextService } from '../global-context';
import { WorkspaceScope, WorkspaceService } from '../workspace';
import { SaudeDaSincronizacaoService } from './services/saude-da-sincronizacao';

export { SaudeDaSincronizacaoService } from './services/saude-da-sincronizacao';
export { AvisoDeSincronizacao } from './views/aviso';

export function configureTuninhoSincronizacaoModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .service(SaudeDaSincronizacaoService, [
      WorkspaceService,
      GlobalContextService,
    ]);
}
